import { render, staticRenderFns } from "./FileIcon.vue?vue&type=template&id=a491630e&"
import script from "./FileIcon.vue?vue&type=script&lang=js&"
export * from "./FileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports